export default __webpack_public_path__ + "static/03-b-underline-exceed-c6c8908f4f30f2deec5464baa8a4bf13.svg";